module.exports = __webpack_public_path__ + "static/media/small_gift_icon.89e7e390.svg";